import { elementTypes } from '../../shared/elements.ts';
import { creatureText } from '../../shared/game-config.ts';
import { describeEffect, ENERGY_MAX, type Move } from '../../shared/moves.ts';
import { el } from '../common/dom.ts';
import { icon } from '../common/icons.ts';

/**
 * Carte d'une attaque (nom, énergie, type, puissance, précision, effets), à la couleur de son type ; un bouton si
 * `onClick` est donné. Fiche du monstre, choix d'une attaque à apprendre.
 */
export function moveCard(move: Move, selected = false, onClick?: () => void): HTMLElement {
  const element = elementTypes.get(move.element);
  const details = [move.category === 'damage' ? `Puiss. ${move.power}` : 'Statut', move.accuracy === null ? 'ne rate jamais' : `Préc. ${move.accuracy} %`,
    ...move.effects.map(describeEffect)].join(' · ');
  const card = el(onClick ? 'button' : 'div', { className: `move-card ${selected ? 'selected' : ''}`, title: creatureText(move.description) },
    el('strong', { textContent: move.name }),
    el('span', { className: 'move-pp', title: `Coûte ${move.energy} d'énergie sur ${ENERGY_MAX}` }, icon('energy'), ` ${move.energy}`),
    el('small', {}, icon(element.icon), ` ${element.label} · ${details}`));
  card.style.setProperty('--c', element.color);
  if (onClick) card.addEventListener('click', onClick);
  return card;
}
